/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Error_Add_ChildInputs */



/**
* | output |
* | --- |
* | "Couldn't add the child league." |
*
* @param {League_Error_Add_ChildInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_error_add_child = /** @type {((inputs?: League_Error_Add_ChildInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Error_Add_ChildInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'ajouter la ligue enfant.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo añadir la liga hija.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível adicionar a liga filha.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile aggiungere il campionato figlio.")
	return /** @type {LocalizedString} */ ("Couldn't add the child league.")
});